export const URL_PATHS = {
  LOANPRO_APP: '/loan-pro/app',
  LOANPRO_SETTINGS: '/loan-pro/settings',
  GENERAL_SETTINGS: '/settings/general-settings',
  COMPANY_SETTINGS: '/settings/company-settings'
};

export const LoanProgress = Object.freeze({
  VETTING: 'interview',
  PROCESSING: 'in-progress',
  LOAN_REVIEW: 'loan review',
  APPROVED: 'approved',
  SECURITY_CHECK: 'securities check',
  APPROVAL_REQUEST: 'approval requested',
  APPROVAL_REJECTED: 'approval request rejected',
  WAIVER_APPROVED: 'waiver approved',
  WAIVER_REQUESTED: 'waiver requested',
  WAIVER_REJECTED: 'waiver request rejected',
  CANCELLED: 'cancelled',
  DENIED: 'denied',
  DISBURSED: 'disbursed',
  PENDING_DISBURSEMENT: 'pending disbursement',
  DISBURSEMENT_REJECTED: 'disbursement rejected',
  PARTIALLY_DISBURSEED: 'partially disbursed'
});

export const LoanProgressGrouping = Object.freeze({
  IN_PROGRESS: [
    LoanProgress.VETTING,
    LoanProgress.PROCESSING,
    LoanProgress.LOAN_REVIEW,
    LoanProgress.LOAN_REVIEW,
    LoanProgress.SECURITY_CHECK,
    LoanProgress.APPROVED,
    LoanProgress.APPROVAL_REQUEST,
    LoanProgress.APPROVAL_REJECTED,
    LoanProgress.WAIVER_APPROVED,
    LoanProgress.WAIVER_REQUESTED,
    LoanProgress.WAIVER_REJECTED,
    LoanProgress.PENDING_DISBURSEMENT,
    LoanProgress.DISBURSEMENT_REJECTED,
    LoanProgress.PARTIALLY_DISBURSEED
  ],
  AT_REVIEW: [LoanProgress.LOAN_REVIEW, LoanProgress.SECURITY_CHECK],
  AT_APPROVAL: [LoanProgress.APPROVAL_REQUEST, LoanProgress.WAIVER_REQUESTED],
  AT_DISBURSEMENT: [
    LoanProgress.APPROVED,
    LoanProgress.PENDING_DISBURSEMENT,
    LoanProgress.PARTIALLY_DISBURSEED
  ],
  TERMINATED: [LoanProgress.DENIED, LoanProgress.CANCELLED]
});
